/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { FunctionComponent } from 'react';
import GraphImg from '@graphcms/react-image';
import Link from 'next/link';
import * as styles from './ArticleVerticalCard.style';
import { URLObject } from '../../utils/links';

export interface ArticleVerticalCardProps {
  title: string,
  abstract?: string,
  dataRef?: string,
  urlObject: URLObject,
  onClick: (path: string) => void,
  imageHandle: string,
  imageAlt: string,
}

const ArticleVerticalCard: FunctionComponent<ArticleVerticalCardProps> = ({
  title,
  abstract,
  dataRef = 'article-card',
  onClick,
  urlObject,
  imageHandle,
  imageAlt,
}) => (
  <article
    data-ref={dataRef}
    onClick={() => onClick(urlObject.as)}
    css={styles.base}
  >
    <div css={styles.imageWrapper}>
      {imageHandle ? (
        <GraphImg
          image={{
            handle: imageHandle,
            width: 340,
            height: 224,
          }}
          maxWidth={300}
          alt={imageAlt}
          blurryPlaceholder={false}
          backgroundColor
          fadeIn={false}
        />
      ) : (
        <div css={styles.imagePlaceholder} />
      )}
    </div>
    <div css={styles.info}>
      <h3
        css={styles.title}
        data-ref={`${dataRef}-title`}
      >
        <Link
          href={urlObject.url}
          as={urlObject.as}
        >
          {title}
        </Link>
      </h3>
      {abstract && (
        <p css={styles.abstract}>
          {abstract}
        </p>
      )}
    </div>
  </article>
);

export default ArticleVerticalCard;
